import Image from "next/image";
import dayjs from "dayjs";
import clsx from "clsx";
import { ContentfulLivePreview } from "@contentful/live-preview";
import { IPage } from "@/types/page";
import {
  CorporateFloatingButtonNav,
  CorporateFloatingNav,
} from "../menu/corporateNav";

export const HeroCorpoPage: React.FC<{ entry: IPage; siblings?: IPage[] }> = ({
  entry,
  siblings,
}: {
  entry: IPage;
  siblings?: IPage[];
}) => {
  return (
    <div className="grid grid-cols-12 w-full bg-white">
      <div className="col-span-12 xl:col-span-4 ">
        <div className="">
          <div className="bg-brand-red bg-line-pattern bg-cover text-white h-full p-6 xl:p-16 xl:pr-10 xl:pb-44 space-y-5 xl:space-y-8 _translate-y-10">
            <div className="flex justify-between items-center">
              {entry.contentfulMetadata.tags && (
                <div className="flex">
                  <p className="border-2 border-white px-2 py-1.5 text-xs font-bold tracking-widest uppercase">
                    Grand Paris Aménagement
                  </p>
                </div>
              )}
              <div className="relative xl:hidden">
                {siblings && (
                  <CorporateFloatingNav
                    pages={siblings}
                    currentPageId={entry.sys.id}
                  />
                )}
              </div>
            </div>
            <h1
              className={clsx(
                " font-bold",
                entry.title.length <= 20
                  ? `text-3xl xl:text-4xl`
                  : entry.title.length <= 35
                  ? `text-2xl xl:text-4xl`
                  : `text-xl xl:text-3xl`
              )}
              {...ContentfulLivePreview.getProps({
                entryId: entry.sys.id,
                fieldId: "title",
              })}
            >
              {entry.title}
            </h1>
          </div>
          <div className="hidden xl:flex bg-brand-blue text-white p-12 grid-cols-2 gap-y-2 ">
            <div className="relative z-10">
              <CorporateFloatingButtonNav
                pages={siblings ?? []}
                currentPageId={entry.sys.id}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="col-span-12 xl:col-span-8 xl:border-l">
        <div
          {...ContentfulLivePreview.getProps({
            entryId: entry.sys.id,
            fieldId: "image",
          })}
          className="w-full xl:w-[calc(100%+1px)] xl:-ml-[1px] lg:h-[350px]"
        >
          {!entry.image?.url && (
            <div className="hidden lg:block w-full h-full bg-gray-300" />
          )}

          {entry.image?.url && (
            <>
              <Image
                src={`${entry.image.url}?w=700&h=700&fit=fill&q=50&fm=webp`}
                sizes="100vw"
                alt={entry.image.title}
                width={700}
                height={700}
                className="xl:hidden w-full h-full object-cover"
                loading="eager"
              />
              <Image
                src={`${entry.image.url}?w=1280&h=600&fit=fill&q=50&fm=webp`}
                sizes="100vw"
                alt={entry.image.title}
                width={1280}
                height={400}
                className="hidden xl:block w-full h-full object-cover"
                loading="eager"
              />
            </>
          )}
        </div>

        <div className="xl:block">
          <div className="shadow-lg bg-white p-6 xl:p-16 xl:-translate-x-14 xl:-translate-y-24 space-y-6 relative z-10 bg-line-pattern bg-[length:600px_600px] ">
            {entry.intro && (
              <p
                {...ContentfulLivePreview.getProps({
                  entryId: entry.sys.id,
                  fieldId: "intro",
                })}
                className="text-2xl text-brand-blue"
              >
                {entry.intro}
              </p>
            )}
            <div className="flex">
              <div className="h-1 bg-brand-red w-14" />
            </div>
            {entry.sys.publishedAt && (
              <p className="text-sm text-gray-600">
                Mise à jour le{" "}
                {dayjs(entry.sys.publishedAt).format(`DD/MM/YYYY`)}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
